import { LoadingButton } from "@mui/lab";
import { Box, Grid, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AddOnItemName } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import { getSource, trackEvent } from "utils/tracking";

interface Props {
  checkoutForSplashPage: (plan: any) => void;
  fetchUserLoading: boolean;
  notQualified: boolean;
  plan: Plans | AddOnItemName;
  fromRoutes: string;
  planDetails: JSX.Element;
  buttonTextBefore?: JSX.Element;
  buttonText?: JSX.Element;
  buttonLabel?: string;
}

const ProgramInfo = ({
  checkoutForSplashPage,
  fetchUserLoading,
  notQualified,
  plan,
  fromRoutes,
  planDetails,
  buttonTextBefore,
  buttonText,
  buttonLabel = "Check Out",
}: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { currentOrg } = useContext(OrganizationUserContext);

  const clickGo = async () => {
    trackEvent("Splash Page - Checkout Button Clicked", {
      source: getSource(),
      routes: fromRoutes,
    });
    if (currentOrg?.id) {
      await checkoutForSplashPage(plan);
    } else {
      navigate(`/${fromRoutes}/sign-up${location.search}`);
    }
  };

  return (
    <Box sx={{ py: 2, px: { xs: 3, md: 6 } }}>
      {planDetails}

      <Grid container justifyContent="center" sx={{ mt: 3, mb: 1 }}>
        <Grid item xs={12}>
          <Typography sx={{ mb: 2 }} textAlign="center" component="div">
            {" "}
            {buttonTextBefore}
          </Typography>
        </Grid>

        <LoadingButton
          disableElevation
          variant="contained"
          onClick={clickGo}
          loading={fetchUserLoading}
        >
          {notQualified ? "Go to Dashboard" : buttonLabel}
          <Box
            sx={{ ml: 1 }}
            component="i"
            className="fa-regular fa-arrow-right"
          />
        </LoadingButton>
      </Grid>
      <Typography textAlign="center" component="div" sx={{ mt: 2 }}>
        {buttonText}
      </Typography>
    </Box>
  );
};

export default ProgramInfo;
